module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', {
    staticClass: "confirm-email-page center-align"
  }, [(!_vm.data.success) ? _c('div', [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Weryfikacja adresu e-mail")]), _vm._v(" "), (_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('p', {
    staticClass: "card-subtitle center-align red-text"
  }, [_vm._v("\n        " + _vm._s(_vm.data.errors['message'].join(', ')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.data.errors['email']) ? _c('p', {
    staticClass: "card-subtitle center-align red-text"
  }, [_vm._v("\n        " + _vm._s(_vm.data.errors['email'].join(', ')) + "\n      ")]) : _c('p', {
    staticClass: "card-subtitle center-align red-text"
  }, [_vm._v("\n        Niestety nie udało nam się potwierdzić Twojego adresu email.\n      ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_vm._v("\n          Napisz do nas\n        ")])])]) : _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Weryfikacja Twojego adresu e-mail w toku...\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])]) : _vm._e(), _vm._v(" "), (_vm.data.success) ? _c('div', [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Gratulacje!")]), _vm._v(" "), (_vm.data.message) ? _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      " + _vm._s(_vm.data.message) + "\n    ")]) : _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("\n      Twój e-mail został poprawnie zweryfikowany!\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.auth()
      }
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_vm._v("\n        Przejdź do aplikacji\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])]) : _vm._e(), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e9caa0f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/confirmEmail.vue
// module id = 378
// module chunks = 0